<template>
  <div class="cn-page">

    <!-- Hero -->
    <div class="cn-hero">
      <div class="d-flex align-center" style="gap:14px;">
        <v-avatar color="rgba(255,255,255,0.15)" size="46">
          <v-icon color="white" size="26">mdi-contacts-outline</v-icon>
        </v-avatar>
        <div>
          <div class="cn-hero__title">Mis Contactos Registrados</div>
          <div class="cn-hero__sub">Gestión y seguimiento de contactos de prospección</div>
        </div>
      </div>
      <div class="d-flex align-center" style="gap:8px;" v-if="!$store.state.isonlyread">
        <router-link to="excelcontactos" style="text-decoration:none;">
          <v-btn small dark depressed color="rgba(255,255,255,0.18)">
            <v-icon left small>mdi-file-upload-outline</v-icon> Subir Contactos
          </v-btn>
        </router-link>
        <v-btn small dark depressed color="rgba(255,255,255,0.18)" @click="editarcontacto(null); window.$('#modal-contacto').modal('show')">
          <v-icon left small>mdi-account-plus-outline</v-icon> Registrar contacto
        </v-btn>
      </div>
    </div>

    <div class="cn-body">

      <!-- Filtros -->
      <v-card outlined class="cn-filter-card mb-4">
        <v-card-title class="cn-section-title py-2 px-4">
          <v-icon small color="indigo darken-2" class="mr-1">mdi-filter-outline</v-icon>
          Filtros de búsqueda
        </v-card-title>
        <v-card-text class="pt-3 pb-3 px-4">
          <v-row dense align="center">
            <v-col cols="12" sm="3">
              <div class="cn-field-label mb-1">Desde</div>
              <Fechas :model="fechas" :valueto="'fecha_ini'" :default="fechas.fecha_ini" />
            </v-col>
            <v-col cols="12" sm="3">
              <div class="cn-field-label mb-1">Hasta</div>
              <Fechas :model="fechas" :valueto="'fecha_fin'" :default="fechas.fecha_fin" />
            </v-col>
            <v-col cols="12" sm="3" v-if="$store.state.getContactos">
              <v-text-field
                v-model.trim="search"
                :placeholder="txtsearch"
                dense outlined hide-details clearable
                prepend-inner-icon="mdi-magnify"
                label="Buscar"
              />
            </v-col>
            <v-col cols="12" sm="3" v-if="$store.state.getContactos && idcargo != 13">
              <div class="cn-field-label mb-1" v-show="idcargo == 1 || idcargo == 11 || idcargo == 12">Asesor</div>
              <UsuariosActivos :models="asesorsel" :multiple="false" :xonlyasesores="true" />
            </v-col>
            <v-col cols="12" sm="12" v-if="idcargo == 1">
              <v-checkbox
                v-model="listartodos"
                label="Listar todos los contactos sin importar el asesor (solo master)"
                dense hide-details class="mt-0"
              />
            </v-col>
            <v-col cols="12" class="d-flex align-center" style="gap:10px;">
              <v-btn color="indigo darken-1" dark depressed @click="btnBuscar()">
                <v-icon left small>mdi-magnify</v-icon> Buscar contactos
              </v-btn>
              <span v-if="msg" class="grey--text" style="font-size:0.82rem;">{{ msg }}</span>
              <span v-if="txtresultadosearch" class="indigo--text text--darken-1" style="font-size:0.82rem;">
                <v-icon small color="indigo darken-1">mdi-information-outline</v-icon>
                {{ txtresultadosearch }}
              </span>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>

      <!-- Resultados -->
      <v-card outlined class="cn-table-card" v-if="contactos.length > 0">

        <!-- Toolbar resultados -->
        <div class="cn-table-toolbar px-4 py-2 d-flex flex-wrap align-center" style="gap:8px;">
          <v-chip x-small color="indigo lighten-5" class="indigo--text text--darken-2 font-weight-medium">
            {{ contactos.length }} contacto{{ contactos.length !== 1 ? 's' : '' }}
          </v-chip>
          <v-text-field
            v-model="buscar"
            placeholder="Filtrar en la tabla..."
            prepend-inner-icon="mdi-filter-variant"
            dense outlined hide-details clearable
            style="max-width:260px;"
          />
          <v-spacer />
          <v-btn small depressed color="red lighten-5" class="red--text text--darken-2"
            @click="eliminarseleccionados()">
            <v-icon left small>mdi-delete-outline</v-icon> Eliminar seleccionados
          </v-btn>
          <v-btn small depressed color="grey lighten-3" :disabled="$store.state.isonlyread"
            @click="tableToExcel('table', 'Contactos')">
            <v-icon left small>mdi-microsoft-excel</v-icon> Excel
          </v-btn>
        </div>

        <v-divider />

        <v-data-table
          :headers="headers"
          :items="contactos"
          :search="buscar"
          :items-per-page="25"
          :footer-props="{ itemsPerPageOptions: [10, 25, 50, 100, -1] }"
          dense
          class="cn-table"
          no-data-text="Sin contactos."
        >
          <!-- Acciones -->
          <template v-slot:[`item.acciones`]="{ item }">
            <div class="d-flex align-center" style="gap:4px;">
              <v-checkbox v-if="item.id" v-model="item.checkbox" dense hide-details class="mt-0 pt-0" />
              <v-tooltip bottom v-if="item.id && !noeditar">
                <template v-slot:activator="{ on }">
                  <v-btn icon x-small color="indigo darken-1" v-on="on"
                    @click="editarcontacto(item); window.$('#modal-contacto').modal('show')">
                    <v-icon x-small>mdi-pencil-outline</v-icon>
                  </v-btn>
                </template>
                <span>Editar contacto</span>
              </v-tooltip>
            </div>
          </template>

          <!-- Teléfono WhatsApp -->
          <template v-slot:[`item.telefono`]="{ item }">
            <span class="cn-wa-link" @click="openwhatsapp(item)" title="Abrir WhatsApp">
              <v-icon x-small color="green darken-2" class="mr-1">mdi-whatsapp</v-icon>
              {{ item.telefono }}
            </span>
          </template>

          <!-- Estado -->
          <template v-slot:[`item.estado`]="{ item }">
            <v-menu bottom offset-y>
              <template v-slot:activator="{ on }">
                <v-chip small label :color="estadoColor(item.estado)" :dark="estadoDark(item.estado)"
                  v-on="on" style="min-width:120px; justify-content:space-between; cursor:pointer;">
                  {{ item.estado }}
                  <v-icon right x-small>mdi-chevron-down</v-icon>
                </v-chip>
              </template>
              <v-list dense>
                <v-list-item v-for="(x, i) in estadoscontactos" :key="i"
                  @click="item.estado = x; actualizar(item)">
                  <v-chip small label :color="estadoColor(x)" :dark="estadoDark(x)" style="min-width:130px;">
                    {{ x }}
                  </v-chip>
                </v-list-item>
              </v-list>
            </v-menu>
          </template>

          <!-- Intereses -->
          <template v-slot:[`item.intereses`]="{ item }">
            <span style="font-size:0.78rem;">{{ mergetextintereses(item.intereses) }}</span>
          </template>

        </v-data-table>
      </v-card>

    </div>

    <notifications group="auth" position="bottom right" />
    <Modal :padre="contactosel" :listado="contactos" />

    <!-- Tabla oculta para Excel -->
    <table ref="table" style="display:none;" summary="Contactos">
      <thead>
        <tr>
          <th>Nro</th><th>Fecha Registro</th><th>Carnet</th><th>Nombres</th>
          <th>Apellido 1</th><th>Apellido 2</th><th>Telefono</th><th>Correo</th>
          <th>Fecha Visita</th><th>Ciudad</th><th>Estado</th><th>Intereses</th>
          <th>Profesion</th><th>Empresa</th><th>Direccion</th><th>Observacion</th>
          <th>Latitud</th><th>Longitud</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(e, i) in contactos" :key="e.id || i">
          <td>{{ i + 1 }}</td>
          <td>{{ e.fecha_registro }}</td>
          <td>{{ e.numero_documento }}</td>
          <td>{{ e.nombres }}</td>
          <td>{{ e.primer_apellido }}</td>
          <td>{{ e.segundo_apellido }}</td>
          <td>{{ e.telefono }}</td>
          <td>{{ e.correo }}</td>
          <td>{{ e.fecha_visita }}</td>
          <td>{{ e.ciudad }}</td>
          <td>{{ e.estado }}</td>
          <td>{{ mergetextintereses(e.intereses) }}</td>
          <td>{{ e.profesion }}</td>
          <td>{{ e.empresa }}</td>
          <td>{{ e.direccion }}</td>
          <td>{{ e.observacion }}</td>
          <td>{{ e.latitud }}</td>
          <td>{{ e.longitud }}</td>
        </tr>
      </tbody>
    </table>

  </div>
</template>

<script>
import { error } from "@/components/Utils.js";
import UsuariosActivos from "@/components/AUsuariosActivos2";
import Fechas from "@/components/AFecha";
import Modal from "@/components/AModal-contacto";
import { getheadersrest } from "@/components/Utils";

export default {
  components: { UsuariosActivos, Fechas, Modal },
  data() {
    return {
      // EXCEL
      uri: "data:application/vnd.ms-excel;base64,",
      template: '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head> <meta charset="utf-8"> <!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--></head><body><table>{table}</table></body></html>',
      base64: function(s) { return window.btoa(unescape(encodeURIComponent(s))); },
      format: function(s, c) { return s.replace(/{(\w+)}/g, function(m, p) { return c[p]; }); },
      // END EXCEL
      headers: [
        { text: 'Acc.',           value: 'acciones',         width: 80,  sortable: false },
        { text: 'F. Registro',    value: 'fecha_registro',   width: 110 },
        { text: 'Carnet',         value: 'numero_documento', width: 100 },
        { text: 'Nombres',        value: 'nombres',          width: 130 },
        { text: 'Apellido 1',     value: 'primer_apellido',  width: 120 },
        { text: 'Apellido 2',     value: 'segundo_apellido', width: 120 },
        { text: 'Teléfono',       value: 'telefono',         width: 120 },
        { text: 'Correo',         value: 'correo',           width: 160 },
        { text: 'F. Visita',      value: 'fecha_visita',     width: 100 },
        { text: 'Ciudad',         value: 'ciudad',           width: 110 },
        { text: 'Estado',         value: 'estado',           width: 150 },
        { text: 'Intereses',      value: 'intereses',        width: 160 },
        { text: 'Profesión',      value: 'profesion',        width: 130 },
        { text: 'Empresa',        value: 'empresa',          width: 130 },
        { text: 'Dirección',      value: 'direccion',        width: 150 },
        { text: 'Observación',    value: 'observacion',      width: 160 },
        { text: 'Latitud',        value: 'latitud',          width: 90  },
        { text: 'Longitud',       value: 'longitud',         width: 90  },
      ],
      txtsearch: "Carnet, nombre, profesión, ciudad o interés...",
      txtresultadosearch: "",
      listartodos: false,
      noeditar: true,
      msg: "",
      buscar: "",
      nom_us: "",
      search: null,
      contactos_size: "",
      asesorsel: { usuarios: {} },
      contactosel: {},
      fechas: { fecha_ini: "", fecha_fin: "" },
      contactos: [],
      estadoscontactos: ["En Proceso", "Interesado", "Convertido", "Archivado", "No Calificado"],
      idcargo: 13,
    };
  },
  watch: {
    "$store.state.DATA_USER.cargo": function() {
      if (this.$store.state.DATA_USER.cargo) this.idcargo = this.$store.state.DATA_USER.cargo.id;
      this.getMisContactos();
    },
    "$store.state.DATA_USER": function() { this.gen_nom_us(); },
  },
  methods: {
    tableToExcel(table, name) {
      if (!table.nodeType) table = this.$refs.table;
      var ctx = { worksheet: name || "Worksheet", table: table.innerHTML };
      var link = document.createElement("a");
      link.download = "contactos.xls";
      link.href = this.uri + this.base64(this.format(this.template, ctx));
      link.click();
    },
    estadoColor(estado) {
      if (estado === "En Proceso")    return "cyan lighten-3";
      if (estado === "Interesado")    return "cyan lighten-1";
      if (estado === "Convertido")    return "green lighten-2";
      if (estado === "Archivado")     return "grey lighten-1";
      if (estado === "No Calificado") return "red darken-1";
      return "grey lighten-3";
    },
    estadoDark(estado) {
      return estado === "No Calificado";
    },
    gen_nom_us() {
      var data_user = this.$store.state.DATA_USER;
      if (!data_user) return;
      if (!data_user.seg_apellido) data_user.seg_apellido = "";
      this.nom_us = data_user.nombres + " " + data_user.pri_apellido + " " + data_user.seg_apellido;
    },
    estadosfromexcel(estado) {
      if (!this.estadoscontactos.includes(estado)) this.estadoscontactos.push(estado);
    },
    estadosfromexcelremove(texto) {
      this.estadoscontactos = this.estadoscontactos.filter(v => v != texto);
    },
    isFechasValidas() {
      var fi = this.fechas.fecha_ini;
      var ff = this.fechas.fecha_fin;
      return /^[0-9]{4}-[0-9]{2}-[0-9]{2}$/.test(fi) && /^[0-9]{4}-[0-9]{2}-[0-9]{2}$/.test(ff);
    },
    parseFecha(f) {
      if (!f) return "";
      let fs = f.split("-");
      return fs[2] + "/" + fs[1] + "/" + fs[0];
    },
    btnBuscar() { this.getMisContactos(); },
    editarcontacto(c) { this.contactosel = c; },
    mergetextintereses(intereses) {
      if (!intereses) return "-";
      var txt = "";
      intereses.forEach(function(e) { txt += e.nombre + ", "; });
      return txt.length > 0 ? txt.substring(0, txt.length - 2) : txt;
    },
    getMisContactos() {
      let idasesor = this.$store.state.DATA_USER.id;
      if (this.asesorsel.usuarios && this.asesorsel.usuarios.id) idasesor = this.asesorsel.usuarios.id;
      if (!this.isFechasValidas()) {
        this.$notify(error("Error de Fechas", "Ingrese el rango de fechas"));
        return;
      }
      const vue = this;
      let myHeaders = getheadersrest();
      let body = {};
      if (!this.listartodos) body.asesor_id = idasesor;
      if (this.search && this.search.length > 0) body.search_text = this.search;
      body.fecha_inicio = this.parseFecha(this.fechas.fecha_ini);
      body.fecha_fin = this.parseFecha(this.fechas.fecha_fin);
      vue.contactos = [];
      this.msg = "Cargando datos...";
      this.txtresultadosearch = "";
      fetch(process.env.VUE_APP_API_REST + "/api/esam/contacto/search", {
        method: "POST", headers: myHeaders, body: JSON.stringify(body), redirect: "follow",
      })
        .then(r => r.json())
        .then(result => {
          if (result.error) {
            vue.contactos = [];
            vue.msg = result.error;
          } else {
            result.forEach(e => vue.estadosfromexcel(e.estado));
            vue.contactos = result;
            vue.msg = "";
            vue.texto();
          }
        })
        .catch(() => { vue.msg = ""; });
    },
    texto() {
      this.txtresultadosearch = "Se han encontrado " + this.contactos.length + ' contactos; desde "' +
        this.parseFecha(this.fechas.fecha_ini) + " HASTA EL " + this.parseFecha(this.fechas.fecha_fin) + '"';
      if (this.search) this.txtresultadosearch += ' que contienen "' + this.search + '"';
    },
    eliminarseleccionados() {
      let iduser = this.$store.state.DATA_USER.id;
      if (this.asesorsel.usuarios.id && this.asesorsel.usuarios.id != iduser) {
        this.$dialog.alert({ title: "No puedes eliminar contactos de otro usuario.", body: "Por razones de seguridad, solo puedes eliminar tus propios contactos." })
          .then(function() {}).catch(function() {});
        return;
      }
      var seleccionados = this.contactos.filter(e => e.checkbox).map(e => e.id);
      if (seleccionados.length == 0) {
        this.$dialog.alert({ title: "No ha seleccionado ningún contacto", body: "" })
          .then(function() {}).catch(function() {});
      } else {
        const vue = this;
        this.$dialog.confirm({
          title: "Confirmar eliminación de " + seleccionados.length + " contactos.",
          body: "<br><b>NOTA:</b> Esta acción es irreversible.",
        }, {
          verification: "eliminar",
          verificationHelp: 'Escriba "[+:verification]" para confirmar.',
          okText: "Eliminar contactos", cancelText: "Cancelar",
          backdropClose: false, animation: "bounce", loader: true, type: "hard",
        }).then(dialog => { vue.eliminarcontactos(dialog, seleccionados); }).catch(() => {});
      }
    },
    eliminarcontactos(dialog, seleccionados) {
      window.console.log(seleccionados);
      const vue = this;
      Promise.all(seleccionados.map(e =>
        fetch(process.env.VUE_APP_API_REST + "/api/esam/contacto/id/" + e, { method: "DELETE", redirect: "follow" })
      ))
        .then(responses => Promise.all(responses.map(r => r.json())))
        .then(data => {
          window.console.log(data);
          vue.contactos = vue.contactos.filter(e => !seleccionados.includes(e.id));
          vue.texto();
          dialog.close();
        })
        .catch(() => { dialog.close(); });
    },
    openwhatsapp(c) {
      window.open(`${process.env.VUE_APP_API_WHATSAPP}591${c.telefono1}&text=`);
    },
    async actualizar(contacto) {
      let xcontacto = window.Object.assign({}, contacto);
      xcontacto.contacto_id = xcontacto.id;
      delete xcontacto.id;
      for (var propName in xcontacto) {
        if (!xcontacto[propName] || xcontacto[propName] === null || xcontacto[propName] === undefined)
          delete xcontacto[propName];
      }
      let myHeaders = getheadersrest();
      var raw = JSON.stringify(xcontacto);
      window.console.log(raw);
      const vue = this;
      this.estadosfromexcel("Actualizando...");
      contacto.estado = "Actualizando...";
      fetch(process.env.VUE_APP_API_REST + "/api/esam/contacto", {
        method: "PUT", headers: myHeaders, body: raw, redirect: "follow",
      })
        .then(r => r.json())
        .then(result => {
          window.console.log("result:", result);
          contacto.estado = result.result ? xcontacto.estado : result.error;
          vue.estadosfromexcelremove("Actualizando...");
        })
        .catch(() => { vue.estadosfromexcelremove("Actualizando..."); });
    },
  },
  mounted() {
    let unidad = this.$store.state.CARGO.sede.unidad_negocio;
    this.noeditar = unidad == 2;

    var date = new Date();
    var dia = date.getDate();
    var mes = date.getMonth() + 1;
    if (dia == 1) dia = 2;
    if (dia < 10) dia = "0" + dia;
    if (mes < 10) mes = "0" + mes;
    this.fechas.fecha_ini = date.getFullYear() + "-" + mes + "-01";
    this.fechas.fecha_fin = date.getFullYear() + "-" + mes + "-" + dia;

    if (this.$store.state.CARGO.cargo) this.idcargo = this.$store.state.CARGO.cargo.id;
    this.gen_nom_us();
    this.getMisContactos();
  },
};
</script>

<style scoped>
.cn-page { min-height: 100vh; background: #f5f7fa; }

.cn-hero {
  background: linear-gradient(120deg, #1a237e 0%, #283593 50%, #1565c0 100%);
  padding: 20px 28px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 12px;
}
.cn-hero__title { font-size: 1.15rem; font-weight: 700; color: #fff; letter-spacing: 0.02em; }
.cn-hero__sub   { font-size: 0.78rem; color: rgba(255,255,255,0.65); margin-top: 2px; }

.cn-body { padding: 20px 24px; }

.cn-filter-card  { border-radius: 10px !important; border-color: #e3e8f0 !important; }
.cn-table-card   { border-radius: 10px !important; border-color: #e3e8f0 !important; overflow: hidden; }

.cn-section-title {
  font-size: 0.82rem !important;
  font-weight: 700 !important;
  color: #283593;
  letter-spacing: 0.02em;
  border-bottom: 1px solid #e8edf7;
}

.cn-field-label {
  font-size: 0.72rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: #7986cb;
}

.cn-table-toolbar { background: #fafbff; border-bottom: 1px solid #e8edf7; }

.cn-table >>> thead tr th {
  background: #e8edf7 !important;
  color: #1a237e !important;
  font-size: 0.70rem !important;
  font-weight: 700 !important;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  border-bottom: 2px solid #c5cae9 !important;
  padding: 5px 8px !important;
  white-space: nowrap;
}
.cn-table >>> tbody tr:hover { background: #f0f4ff !important; }
.cn-table >>> tbody tr td {
  font-size: 0.80rem;
  border-bottom: 1px solid #f0f0f0 !important;
  padding: 4px 8px !important;
  vertical-align: middle;
  white-space: nowrap;
}

.cn-wa-link {
  cursor: pointer;
  color: #1565c0;
  font-weight: 500;
}
.cn-wa-link:hover { text-decoration: underline; }
</style>
